var path = '/templates/zenclerk_s/sites/dashboard/dashboard-main.html';
var html = "<div class=\"container container-limited dashboard-main\"><div class=\"row widget-list\"></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_s_modules/zenclerk_s/sites/dashboard/dashboard-main.html
// module id = 1404
// module chunks = 0